import { render, staticRenderFns } from "./SearchShortRead.vue?vue&type=template&id=3ef206af&scoped=true&"
import script from "./SearchShortRead.vue?vue&type=script&lang=js&"
export * from "./SearchShortRead.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ef206af",
  null
  
)

export default component.exports